<template>
  <div class="section-main__warp speed-wrap">
    <ioc-table ref="crud"
               :data="tableData"
               :option="option"
               :page="page"
               @search-change="handleSearchChange"
               @search-reset="handleSearchReset"
               @size-change="handleSizeChange"
               @current-change="handleCurrentChange">
      <!-- 顶部按钮 自定义 -->
      <template slot="menuLeft">
        <el-button v-auth="'/carspeed/speedConfig:add'"
                   type="primary"
                   size="small"
                   class="iss-operation-button"
                   icon="el-icon-plus"
                   @click="handleAddAccount">
          {{$t('workGroup.button.add')}}
        </el-button>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu"
                slot-scope="scope">
        <el-tooltip class="item"
                    effect="dark"
                    content="修改"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     icon="iconfont icon-xiugai"
                     v-auth="'/carspeed/speedConfig:update'"
                     @click="handleEdit(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     icon="el-icon-delete"
                     v-auth="'/carspeed/speedConfig:delete'"
                     @click="handleDel(scope.row)"></el-button>
        </el-tooltip>
        <el-tooltip class="item"
                    effect="dark"
                    content="详情"
                    placement="top"
                    popper-class="tooltip-draw">
          <el-button type="text"
                     icon="iconfont icon-Detail"
                     @click="handleView(scope.row)"></el-button>
        </el-tooltip>
        <el-tooltip class="item m5"
                    effect="dark"
                    content="记录查询"
                    placement="top-start">
          <span class="iconfont-lunan icon-blue icon-lunan-tiaozhuan"
                @click="goToRecord(scope.row)"></span>&nbsp;&nbsp;&nbsp;&nbsp;
        </el-tooltip>
      </template>
      <!-- 表格列 状态 -->
      <template slot="status"
                slot-scope="scope">
        <el-switch v-auth="'/carspeed/speedConfig:update'"
                   v-model="scope.row.status"
                   active-value="1"
                   inactive-value="2"
                   @change="handleUpdateStatus(scope.row)"></el-switch>
        {{ scope.row.$status }}
      </template>
    </ioc-table>
    <add-config ref="add"></add-config>
    <detail-config ref="view"></detail-config>
  </div>
</template>
<script>
import { api } from '../api'
import tableOption from '../const/configOption'
import utils from '@src/common/utils'
import { Dic, Bus, Dates } from '$utils'
import addConfig from '../components/add-config'
import detailConfig from '../components/detail-config'
export default {
  components: {
    addConfig,
    detailConfig
  },
  data () {
    return {
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10
      },
      searchParams: {},
      option: tableOption(this),
      rowInfo: {}
    }
  },
  mounted () {
    this.getList()
  },
  created () {
  },
  computed: {
  },
  methods: {
    goToRecord (row) {
      this.$router.push({
        path: "/carspeed/speedRecord",
        name: "speedRecord",
        query: {
          taskName: row.taskName
        },
      });
    },
    handleSearchReset () {
      this.getList()
    },
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const params = {
        taskName: this.searchParams.taskName ? this.searchParams.taskName : '',//'任务名称'
        status: this.searchParams.status ? this.searchParams.status : null,//任务状态
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      this.$fetch(
        api.measurespeed.queryMeasureSpeed,
        params
      ).then(response => {
        setTimeout(() => {
          loading.close()
        }, 500);
        if (!response.success) {
          this.$message.error(res.msgContent)
          return
        } else {
          this.tableData = response.returnObj ? Object.freeze([...response.returnObj.list]) : []
          this.page.total = response.returnObj ? response.returnObj.total : 0
          this.$refs.crud.selectClear()
        }
      })
    },
    handleCurrentChange (val) {
      this.page.currentPage = val
      this.getList()
    },
    handleSizeChange (val) {
      this.page.currentPage = 1;
      this.page.pageSize = val
      this.getList()
    },
    handleSearchChange (param) {
      this.searchParams = param;
      this.$log.debug('查询条件', this.searchParams)
      this.page.currentPage = 1;
      this.getList();
    },
    handleAddAccount () {
      this.$refs.add.openDialog(1);
      this.$nextTick(() => {
        this.$refs.add.showMap();
      })
    },
    handleEdit (row) {
      this.$refs.add.openDialog(2, row);
      this.$nextTick(() => {
        this.$refs.add.showMap();
      })
    },
    handleView (row) {
      this.$refs.view.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.view.open(row);
      })
    },
    handleDel (row) {
      const params = {
        taskCodes: [row.taskCode], //'任务code'
      }
      this.$confirm('您确定删除该任务吗?', '确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$fetch(api.measurespeed.deleteMeasureSpeed, params).then(response => {
          if (response && response.success) {
            this.$message.success(response.msgContent)
            this.getList()
          } else {
            this.$message.error(response.msgContent)
          }
        })
      })
    },
    handleUpdateStatus (row) {
      this.$confirm(`确定要${row.status == '1' ? '启动' : '禁止'}此任务吗`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          taskCode: row.taskCode, //'巡检计划code'
          status: row.status.toString(), //状态 1：启动,2：禁止
        }
        this.$fetch(api.measurespeed.startOrStop, params).then(res => {
          if (res.success) {
            this.$message({
              showClose: false,
              message: `测速任务${row.status === '1' ? '启动' : '禁止'}成功`,
              type: 'success',
              duration: 2000
            })
            this.getList()
          } else {
            this.$message.error(response.msgContent)
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
@import "../style/speed.scss";
</style>
